import React, { useState } from 'react';

import { Stack } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import PackageCategoryFilter from 'components/SalesPortal/PackageCategoryFilter';
import PackageSearchFilters from 'components/SalesPortal/PackageSearchFilters';
import SalesPortalHomePagePackages from 'components/SalesPortal/SalesPortalHomePagePackages';
import { useAuth } from 'context/auth-context';
import useAthleteSalesPortalPackages from 'hooks/salesPortal/useAthleteSalesPortalPackages';
import useSalesPortalPackageCategories from 'hooks/salesPortal/useSalesPortalPackageCategories';
import BackHeader from 'layouts/MobileLayout/components/BackHeader';
import NotFound from 'pages/shared/NotFound';
import { PackageCategoryAutoComplete } from 'types';

const SalesPortalHomePage = (): JSX.Element => {
  const { session } = useAuth();
  const [search, setSearch] = useState<string>('');
  const [debouncedSearch] = useDebouncedValue<string>(search, 250);
  const [packageCategory, setPackageCategory] = useState<PackageCategoryAutoComplete | null>(null);
  const { data: packages, isError: packagesError } = useAthleteSalesPortalPackages(
    session?.gym?.gymId,
    debouncedSearch,
    session?.profile?.profileId,
  );
  const { data: packageCategoriesData } = useSalesPortalPackageCategories({
    gym: session?.gym?.gymId,
  });

  if (packagesError) {
    return <NotFound />;
  }

  return (
    <>
      <BackHeader title={'Explore Packages'} />
      <Stack className='content'>
        <PackageSearchFilters search={search} setSearch={setSearch} />
        <PackageCategoryFilter
          categories={packageCategoriesData?.data || []}
          packageCategory={packageCategory || null}
          setPackageCategory={setPackageCategory || (() => {})}
        />
        <SalesPortalHomePagePackages
          isAthleteAppView={true}
          packages={packages?.data}
          packageCategory={packageCategory}
          setPackageCategory={setPackageCategory}
          gym={session?.gym ?? undefined}
        />
      </Stack>
    </>
  );
};

export default SalesPortalHomePage;
